import { addDays } from 'date-fns';
import { omit } from 'lodash';

import { useGetBaseQueryParams, useGetWhitelabelDomain } from '../../../context/constructorContext';

import { createWidgetLink } from '../../../utils';
import { formatDateToDots, getStartDateByPreset } from '../utils';

interface IRedirectToHotelPage {
  searchParams: Record<string, any>;
  nightsCount?: number;
}
type RedirectToHotelPage = (params: IRedirectToHotelPage) => void;

interface IUseRedirectToHotelPage {
  publicUrl: string;
  redirect: string;
}

export const useRedirectToHotelPage = (
  params: IUseRedirectToHotelPage
): { redirectToHotelPage: RedirectToHotelPage } => {
  const { publicUrl, redirect } = params;

  const baseQueryParams = useGetBaseQueryParams();
  const partnerDomain = useGetWhitelabelDomain();

  const redirectToHotelPage = (params: IRedirectToHotelPage): void => {
    const { searchParams, nightsCount } = params;

    const isNotPreset = searchParams.start_date instanceof Date;
    const startDate = isNotPreset
      ? searchParams.start_date
      : getStartDateByPreset(searchParams.start_date);
    const startDateString = formatDateToDots(startDate);

    const endDate = formatDateToDots(addDays(startDate, nightsCount || searchParams.nights));

    const querySearchParams = omit(
      {
        ...searchParams,
        from: `${searchParams.from_city}-${searchParams.from_country}`,
        ...(nightsCount && { nights: nightsCount }),
        start_date: startDateString,
        start_date_primary: startDateString,
        start_date_till: startDateString,
        end_date: endDate,
        end_date_primary: endDate,
        end_date_till: endDate,
      },
      [
        'hotel_ids',
        'to_city',
        'to_country',
        'flex_dates',
        'from_city',
        'from_country',
        'departure',
        'destination_ids',
        'hotel_id',
      ]
    );

    const qs = {
      ...baseQueryParams,
      ...querySearchParams,
    };
    const link = createWidgetLink(`${partnerDomain}${publicUrl}`, qs);

    window.open(link, redirect);
  };

  return { redirectToHotelPage };
};
